<template>

<app-wrapper>

	<app-text>

		<app-group>

             <app-input-text :label="page.business_profile_about_general_phone_label" v-model="inputs.general_phone" :errored="errored.general_phone" :placeholder="page.business_profile_about_general_phone_placeholder" />
             <app-input-text :label="page.business_profile_about_general_website_label" v-model="inputs.general_website" :errored="errored.general_website" :placeholder="page.business_profile_about_general_website_placeholder" />

                <app-input-text :label="page.business_profile_about_address_1_label" v-model="inputs.address_1" :errored="errored.address_1" :placeholder="page.business_profile_about_address_1_placeholder" />
                <app-input-text :label="page.business_profile_about_address_2_label" v-model="inputs.address_2" :errored="errored.address_2" :placeholder="page.business_profile_about_address_2_placeholder" />
                <app-input-text :label="page.business_profile_about_address_city_label" v-model="inputs.address_city" :errored="errored.address_city" :placeholder="page.business_profile_about_address_city_placeholder" />
                <app-input-select :label="page.business_profile_about_address_county_label" :options="data.counties" v-model="inputs.address_county" :errored="errored.address_county" :placeholder="page.business_profile_about_address_county_placeholder" />
                <app-input-text :label="page.business_profile_about_address_postcode_label" v-model="inputs.address_postcode" :errored="errored.address_postcode" :placeholder="page.business_profile_about_address_postcode_placeholder" />
                <app-input-check :label="page.business_profile_about_address_visible_label" v-model="inputs.address_visible" :errored="errored.address_visible" />

				<app-input-check v-model="inputs.offers" :errored="errored.offers" :label="page.business_complete_offers_label" />
				<app-input-check v-model="inputs.terms" :errored="errored.terms" :label="page.business_complete_terms_label" />

		</app-group>

		<app-group :row="true" :center="true">

			<app-button :success="is.saved" :fail="is.errored" text="Confirm" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

		</app-group>

	</app-text>

</app-wrapper>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
			inputs: {
				offers: 0,
				terms: 0,
				general_phone: '',
                general_website: '',
                address_1: '',
                address_2: '',
                address_city: '',
                address_county: 0,
                address_postcode: '',
                address_visible: 0,
			},
			rules: {
				general_phone: {
                    required: true
                },
				address_1: {
                    required: true
                },
				address_city: {
                    required: true
                },
				address_county: {
                    required: true
                },
				address_postcode: {
                    required: true
                },
				terms: {
					required: true
				}
			}
		}

	},

	methods: {

		onSaveClick: function() {

			this.save('account/complete', this.inputs).then(function() {

				this.$router.push({
					name: 'Dashboard'
				})

			}.bind(this))

		}

	}
}

</script>

<style scoped>

.opening {
    width: 100%;
}

.opening-item {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    margin-right: 5px;
}

.is-mobile .opening-item {
	margin-right: 0px;
	margin-bottom: 5px;
}

.opening-item >>> .input-content {
    flex-direction: column;
}

.opening-item >>> .input-content-label {
    width: 100%;
    line-height: 20px;
}

</style>
